import { createBasicSelector } from 'util/redux'
import { selectCurrentQueryId } from './selectCurrentQueryId'
import { selectSortOptionsByQueryId } from './selectSortOptionsByQueryId'

export const selectSortOptionsByCurrentQueryId = createBasicSelector(state => {
  const currentQueryId = selectCurrentQueryId(state)
  return selectSortOptionsByQueryId(state, currentQueryId)
})
